<template>
  <div>
    <HeaderVue></HeaderVue>
    <BannerVue></BannerVue>
    <EnrollQueryVue
      @success="handleQuerySuccess"
      @fail="handleQueryFail"
      v-show="status == 0"
    ></EnrollQueryVue>
    <EnrollSuccessVue
      :info="queryInfo"
      @navBack="handleNavBack"
      v-show="status == 1"
    ></EnrollSuccessVue>
    <NoEnrollVue
      :showBatchList="showBatchList"
      :info="queryInfo"
      @navBack="handleNavBack"
      @toggle-batch="showBatchList = !showBatchList"
      v-show="status === 2"
    ></NoEnrollVue>

    <BatchWrapperVue
      v-show="showBatchList"
      :batchList="batchList"
    ></BatchWrapperVue>
    <FooterVue></FooterVue>
  </div>
</template>

<script>
import BannerVue from "./components/Banner.vue";
import BatchWrapperVue from "./components/BatchWrapper.vue";
import EnrollQueryVue from "./components/EnrollQuery.vue";
import EnrollSuccessVue from "./components/EnrollSuccess.vue";
import FooterVue from "./components/Footer.vue";
import HeaderVue from "./components/Header.vue";
import NoEnrollVue from "./components/NoEnroll.vue";

import { batchList } from "../../services/enroll";

export default {
  name: "Enroll",
  components: {
    HeaderVue,
    BannerVue,
    FooterVue,
    EnrollQueryVue,
    BatchWrapperVue,
    EnrollSuccessVue,
    NoEnrollVue,
  },
  data() {
    return {
      status: 0, // 0: 未查询, 1: 录取成功 2: 未录取
      batchList: [],
      queryInfo: {},
      showBatchList: true,
    };
  },
  created() {
    this.getBatchList();
  },
  watch: {
    status(newValue) {
      if (newValue === 0) {
        this.showBatchList = true;
      }
    },
  },
  methods: {
    handleNavBack() {
      this.status = 0;
      this.showBatchList = true;
    },

    async getBatchList() {
      const res = await batchList();
      this.batchList = res;
    },
    handleQuerySuccess(info) {
      this.status = 1;
      this.queryInfo = info;
      this.showBatchList = false;
    },
    handleQueryFail(info) {
      this.status = 2;
      this.queryInfo = info;
      this.showBatchList = false;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>